import { request, getBaseUrl, setBaseUrl, sessionFetch } from './http';

export async function getR9BillingCompanies(params = {}) {
    const q = new URLSearchParams(params).toString();
    return request(`/r9/billing-companies${q ? `?${q}` : ''}`);
  }

export async function getR9BillingCompany(id) {
    return request(`/r9/billing-companies/${id}`);
  }

export async function createR9BillingCompany(data) {
    return request('/r9/billing-companies', { method: 'POST', body: JSON.stringify(data) });
  }

export async function updateR9BillingCompany(id, data) {
    return request(`/r9/billing-companies/${id}`, { method: 'PUT', body: JSON.stringify(data) });
  }

export async function deleteR9BillingCompany(id) {
    return request(`/r9/billing-companies/${id}`, { method: 'DELETE' });
  }

export async function getR9BillingCompanyAttachments(id) {
    return request(`/r9/billing-companies/${id}/attachments`);
  }

export async function addR9BillingCompanyAttachment(id, data) {
    return request(`/r9/billing-companies/${id}/attachments`, { method: 'POST', body: JSON.stringify(data) });
  }

export async function deleteR9BillingCompanyAttachment(id, attachmentId) {
    return request(`/r9/billing-companies/${id}/attachments/${attachmentId}`, { method: 'DELETE' });
  }

export async function getR9WasteTransporters(params = {}) {
    const q = new URLSearchParams(params).toString();
    return request(`/r9/waste-transporters${q ? `?${q}` : ''}`);
  }

export async function getR9WasteTransporter(id) {
    return request(`/r9/waste-transporters/${id}`);
  }

export async function createR9WasteTransporter(data) {
    return request('/r9/waste-transporters', { method: 'POST', body: JSON.stringify(data) });
  }

export async function updateR9WasteTransporter(id, data) {
    return request(`/r9/waste-transporters/${id}`, { method: 'PUT', body: JSON.stringify(data) });
  }

export async function deleteR9WasteTransporter(id) {
    return request(`/r9/waste-transporters/${id}`, { method: 'DELETE' });
  }

export async function getR9WasteTransporterAttachments(id) {
    return request(`/r9/waste-transporters/${id}/attachments`);
  }

export async function addR9WasteTransporterAttachment(id, data) {
    return request(`/r9/waste-transporters/${id}/attachments`, { method: 'POST', body: JSON.stringify(data) });
  }

export async function deleteR9WasteTransporterAttachment(id, attachmentId) {
    return request(`/r9/waste-transporters/${id}/attachments/${attachmentId}`, { method: 'DELETE' });
  }

export async function getR9WasteGeneratorFacilities(params = {}) {
    const q = new URLSearchParams(params).toString();
    return request(`/r9/waste-generator-facilities${q ? `?${q}` : ''}`);
  }

export async function getR9WasteGeneratorFacility(id) {
    return request(`/r9/waste-generator-facilities/${id}`);
  }

export async function createR9WasteGeneratorFacility(data) {
    return request('/r9/waste-generator-facilities', { method: 'POST', body: JSON.stringify(data) });
  }

export async function updateR9WasteGeneratorFacility(id, data) {
    return request(`/r9/waste-generator-facilities/${id}`, { method: 'PUT', body: JSON.stringify(data) });
  }

export async function deleteR9WasteGeneratorFacility(id) {
    return request(`/r9/waste-generator-facilities/${id}`, { method: 'DELETE' });
  }

export async function getR9WasteGeneratorFacilityAttachments(id) {
    return request(`/r9/waste-generator-facilities/${id}/attachments`);
  }

export async function addR9WasteGeneratorFacilityAttachment(id, data) {
    return request(`/r9/waste-generator-facilities/${id}/attachments`, { method: 'POST', body: JSON.stringify(data) });
  }

export async function deleteR9WasteGeneratorFacilityAttachment(id, attachmentId) {
    return request(`/r9/waste-generator-facilities/${id}/attachments/${attachmentId}`, { method: 'DELETE' });
  }

export async function getR9DisposalFacilities(params = {}) {
    const q = new URLSearchParams(params).toString();
    return request(`/r9/disposal-facilities${q ? `?${q}` : ''}`);
  }

export async function getR9DisposalFacility(id) {
    return request(`/r9/disposal-facilities/${id}`);
  }

export async function createR9DisposalFacility(data) {
    return request('/r9/disposal-facilities', { method: 'POST', body: JSON.stringify(data) });
  }

export async function updateR9DisposalFacility(id, data) {
    return request(`/r9/disposal-facilities/${id}`, { method: 'PUT', body: JSON.stringify(data) });
  }

export async function deleteR9DisposalFacility(id) {
    return request(`/r9/disposal-facilities/${id}`, { method: 'DELETE' });
  }

export async function getR9DisposalFacilityAttachments(id) {
    return request(`/r9/disposal-facilities/${id}/attachments`);
  }

export async function addR9DisposalFacilityAttachment(id, data) {
    return request(`/r9/disposal-facilities/${id}/attachments`, { method: 'POST', body: JSON.stringify(data) });
  }

export async function deleteR9DisposalFacilityAttachment(id, attachmentId) {
    return request(`/r9/disposal-facilities/${id}/attachments/${attachmentId}`, { method: 'DELETE' });
  }

export async function getR9AwrApprovers() {
    return request('/r9/awr-approvers');
  }

export async function getR9AwrApprover(id) {
    return request(`/r9/awr-approvers/${id}`);
  }

export async function createR9AwrApprover(data) {
    return request('/r9/awr-approvers', { method: 'POST', body: JSON.stringify(data) });
  }

export async function updateR9AwrApprover(id, data) {
    return request(`/r9/awr-approvers/${id}`, { method: 'PUT', body: JSON.stringify(data) });
  }

export async function deleteR9AwrApprover(id) {
    return request(`/r9/awr-approvers/${id}`, { method: 'DELETE' });
  }

export async function getR9CompaniesWithR9() {
    const q = new URLSearchParams({ _cb: String(Date.now()) });
    return request(`/r9/companies-with-r9?${q}`);
  }

export async function getR9SitesWithR9Module() {
    const q = new URLSearchParams({ _cb: String(Date.now()) });
    return request(`/r9/sites-with-r9-module?${q}`);
  }

export async function getR9UsersForR9() {
    return request('/r9/users-for-r9');
  }

export async function getR9QuarterlyReportPreview({ year, quarter }) {
    const q = new URLSearchParams({ year: String(year), quarter });
    return request(`/r9/quarterly-report/preview?${q}`);
  }

export async function getR9AwrExport({ year, month }) {
    const q = new URLSearchParams({ year: String(year), month: String(month) });
    return request(`/r9/awr-export?${q}`);
  }

export async function generateR9QuarterlyReportBlob({ year, quarter }) {
    if (!getBaseUrl()) {
      setBaseUrl(process.env.REACT_APP_API_URL || 'http://localhost:5000');
    }
    const url = `${getBaseUrl().replace(/\/+$/, '')}/api/pdf/generate-r9-quarterly-report`;
    const response = await sessionFetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ year, quarter })
    });
    if (!response.ok) {
      let msg = 'Failed to generate PDF';
      try {
        const err = await response.json();
        msg = err.message || msg;
      } catch (_e) {
        /* ignore */
      }
      throw new Error(msg);
    }
    return response.blob();
  }

export async function generateProjectSchedulePdfBlob(payload) {
    if (!getBaseUrl()) {
      setBaseUrl(process.env.REACT_APP_API_URL || 'http://localhost:5000');
    }
    const url = `${getBaseUrl().replace(/\/+$/, '')}/api/pdf/generate-project-schedule`;
    const response = await sessionFetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload || {})
    });
    if (!response.ok) {
      let msg = 'Failed to generate schedule PDF';
      try {
        const err = await response.json();
        msg = err.message || msg;
      } catch (_e) {
        /* ignore */
      }
      throw new Error(msg);
    }
    const blob = await response.blob();
    if (!blob || blob.size === 0) {
      throw new Error(
        'Server returned an empty PDF. The PDF service may be unavailable (e.g. Chrome/Puppeteer not installed on the server).'
      );
    }
    return blob;
  }

export async function getAuthorizedWasteReceipts(params = {}) {
    const q = new URLSearchParams();
    if (params.companyId != null) q.set('companyId', params.companyId);
    if (params.siteId != null) q.set('siteId', params.siteId);
    const query = q.toString();
    return request(`/r9/authorized-waste-receipts${query ? `?${query}` : ''}`);
  }

export async function getAuthorizedWasteReceipt(id) {
    return request(`/r9/authorized-waste-receipts/${id}`);
  }

export async function createAuthorizedWasteReceipt(data) {
    return request('/r9/authorized-waste-receipts', { method: 'POST', body: JSON.stringify(data) });
  }

export async function updateAuthorizedWasteReceipt(id, data) {
    return request(`/r9/authorized-waste-receipts/${id}`, { method: 'PUT', body: JSON.stringify(data) });
  }

export async function deleteAuthorizedWasteReceipt(id) {
    return request(`/r9/authorized-waste-receipts/${id}`, { method: 'DELETE' });
  }

export async function submitAuthorizedWasteReceipt(id) {
    return request(`/r9/authorized-waste-receipts/${id}/submit`, { method: 'PATCH' });
  }

export async function approveAuthorizedWasteReceipt(id, body = {}) {
    return request(`/r9/authorized-waste-receipts/${id}/approve`, { method: 'PATCH', body: JSON.stringify(body) });
  }

export async function rejectAuthorizedWasteReceipt(id, body = {}) {
    return request(`/r9/authorized-waste-receipts/${id}/reject`, { method: 'PATCH', body: JSON.stringify(body) });
  }

export async function getR9PendingApprovals() {
    return request('/r9/pending-approvals');
  }

export async function getPwsPendingVerifications() {
    return request('/pws/pending-verifications');
  }

export async function getR9MyRejectedAwrs() {
    return request('/r9/my-rejected-awrs');
  }

export async function generateAndSaveAwrPdf(recordId) {
    return request('/pdf/generate-and-save-awr', { method: 'POST', body: JSON.stringify({ recordId }) });
  }

export async function getR9AnalyticalResultForms(params = {}) {
    const q = new URLSearchParams();
    if (params.companyId != null) q.set('companyId', params.companyId);
    if (params.siteId != null) q.set('siteId', params.siteId);
    return request(`/r9/analytical-result-forms${q.toString() ? `?${q}` : ''}`);
  }

export async function getR9AnalyticalResultForm(id) {
    return request(`/r9/analytical-result-forms/${id}`);
  }

export async function createR9AnalyticalResultForm(data) {
    return request('/r9/analytical-result-forms', { method: 'POST', body: JSON.stringify(data) });
  }

export async function updateR9AnalyticalResultForm(id, data) {
    return request(`/r9/analytical-result-forms/${id}`, { method: 'PUT', body: JSON.stringify(data) });
  }

export async function deleteR9AnalyticalResultForm(id) {
    return request(`/r9/analytical-result-forms/${id}`, { method: 'DELETE' });
  }

export async function getR9AnalyticalResultFormAttachments(id) {
    return request(`/r9/analytical-result-forms/${id}/attachments`);
  }

export async function addR9AnalyticalResultFormAttachment(id, data) {
    return request(`/r9/analytical-result-forms/${id}/attachments`, { method: 'POST', body: JSON.stringify(data) });
  }

export async function deleteR9AnalyticalResultFormAttachment(id, attachmentId) {
    return request(`/r9/analytical-result-forms/${id}/attachments/${attachmentId}`, { method: 'DELETE' });
  }

export async function getR9SolidWastes(params = {}) {
    const q = new URLSearchParams();
    if (params.companyId != null) q.set('companyId', params.companyId);
    return request(`/r9/solid-wastes${q.toString() ? `?${q}` : ''}`);
  }

export async function getR9SolidWaste(id) {
    return request(`/r9/solid-wastes/${id}`);
  }

export async function createR9SolidWaste(data) {
    return request('/r9/solid-wastes', { method: 'POST', body: JSON.stringify(data) });
  }

export async function updateR9SolidWaste(id, data) {
    return request(`/r9/solid-wastes/${id}`, { method: 'PUT', body: JSON.stringify(data) });
  }

export async function deleteR9SolidWaste(id) {
    return request(`/r9/solid-wastes/${id}`, { method: 'DELETE' });
  }

export async function getR9SolidWasteAttachments(id) {
    return request(`/r9/solid-wastes/${id}/attachments`);
  }

export async function addR9SolidWasteAttachment(id, data) {
    return request(`/r9/solid-wastes/${id}/attachments`, { method: 'POST', body: JSON.stringify(data) });
  }

export async function deleteR9SolidWasteAttachment(id, attachmentId) {
    return request(`/r9/solid-wastes/${id}/attachments/${attachmentId}`, { method: 'DELETE' });
  }

export async function getR9ProducedWaterWastes(params = {}) {
    const q = new URLSearchParams();
    if (params.companyId != null) q.set('companyId', params.companyId);
    return request(`/r9/produced-water-wastes${q.toString() ? `?${q}` : ''}`);
  }

export async function getR9ProducedWaterWaste(id) {
    return request(`/r9/produced-water-wastes/${id}`);
  }

export async function createR9ProducedWaterWaste(data) {
    return request('/r9/produced-water-wastes', { method: 'POST', body: JSON.stringify(data) });
  }

export async function updateR9ProducedWaterWaste(id, data) {
    return request(`/r9/produced-water-wastes/${id}`, { method: 'PUT', body: JSON.stringify(data) });
  }

export async function deleteR9ProducedWaterWaste(id) {
    return request(`/r9/produced-water-wastes/${id}`, { method: 'DELETE' });
  }

export async function getR9ProducedWaterWasteAttachments(id) {
    return request(`/r9/produced-water-wastes/${id}/attachments`);
  }

export async function addR9ProducedWaterWasteAttachment(id, data) {
    return request(`/r9/produced-water-wastes/${id}/attachments`, { method: 'POST', body: JSON.stringify(data) });
  }

export async function deleteR9ProducedWaterWasteAttachment(id, attachmentId) {
    return request(`/r9/produced-water-wastes/${id}/attachments/${attachmentId}`, { method: 'DELETE' });
  }

export async function getR9Invoices(params = {}) {
    const q = new URLSearchParams();
    if (params.status != null) q.set('status', params.status);
    if (params.companyId != null) q.set('companyId', params.companyId);
    return request(`/r9/invoices${q.toString() ? `?${q}` : ''}`);
  }

export async function getR9Invoice(id) {
    return request(`/r9/invoices/${id}`);
  }

export async function updateR9Invoice(id, data) {
    return request(`/r9/invoices/${id}`, { method: 'PUT', body: JSON.stringify(data) });
  }

export async function approveR9Invoice(id, data) {
    const options = { method: 'PATCH' };
    if (data) options.body = JSON.stringify(data);
    return request(`/r9/invoices/${id}/approve`, options);
  }

export async function rejectR9Invoice(id, body = {}) {
    return request(`/r9/invoices/${id}/reject`, { method: 'PATCH', body: JSON.stringify(body) });
  }

export async function deleteR9Invoice(id) {
    return request(`/r9/invoices/${id}`, { method: 'DELETE' });
  }

export async function generateAndSaveInvoicePdf(recordId) {
    return request('/pdf/generate-and-save-invoice', { method: 'POST', body: JSON.stringify({ recordId }) });
  }

export const r9ModuleApi = {
  getR9BillingCompanies,
  getR9BillingCompany,
  createR9BillingCompany,
  updateR9BillingCompany,
  deleteR9BillingCompany,
  getR9BillingCompanyAttachments,
  addR9BillingCompanyAttachment,
  deleteR9BillingCompanyAttachment,
  getR9WasteTransporters,
  getR9WasteTransporter,
  createR9WasteTransporter,
  updateR9WasteTransporter,
  deleteR9WasteTransporter,
  getR9WasteTransporterAttachments,
  addR9WasteTransporterAttachment,
  deleteR9WasteTransporterAttachment,
  getR9WasteGeneratorFacilities,
  getR9WasteGeneratorFacility,
  createR9WasteGeneratorFacility,
  updateR9WasteGeneratorFacility,
  deleteR9WasteGeneratorFacility,
  getR9WasteGeneratorFacilityAttachments,
  addR9WasteGeneratorFacilityAttachment,
  deleteR9WasteGeneratorFacilityAttachment,
  getR9DisposalFacilities,
  getR9DisposalFacility,
  createR9DisposalFacility,
  updateR9DisposalFacility,
  deleteR9DisposalFacility,
  getR9DisposalFacilityAttachments,
  addR9DisposalFacilityAttachment,
  deleteR9DisposalFacilityAttachment,
  getR9AwrApprovers,
  getR9AwrApprover,
  createR9AwrApprover,
  updateR9AwrApprover,
  deleteR9AwrApprover,
  getR9CompaniesWithR9,
  getR9SitesWithR9Module,
  getR9UsersForR9,
  getR9QuarterlyReportPreview,
  getR9AwrExport,
  generateR9QuarterlyReportBlob,
  generateProjectSchedulePdfBlob,
  getAuthorizedWasteReceipts,
  getAuthorizedWasteReceipt,
  createAuthorizedWasteReceipt,
  updateAuthorizedWasteReceipt,
  deleteAuthorizedWasteReceipt,
  submitAuthorizedWasteReceipt,
  approveAuthorizedWasteReceipt,
  rejectAuthorizedWasteReceipt,
  getR9PendingApprovals,
  getPwsPendingVerifications,
  getR9MyRejectedAwrs,
  generateAndSaveAwrPdf,
  getR9AnalyticalResultForms,
  getR9AnalyticalResultForm,
  createR9AnalyticalResultForm,
  updateR9AnalyticalResultForm,
  deleteR9AnalyticalResultForm,
  getR9AnalyticalResultFormAttachments,
  addR9AnalyticalResultFormAttachment,
  deleteR9AnalyticalResultFormAttachment,
  getR9SolidWastes,
  getR9SolidWaste,
  createR9SolidWaste,
  updateR9SolidWaste,
  deleteR9SolidWaste,
  getR9SolidWasteAttachments,
  addR9SolidWasteAttachment,
  deleteR9SolidWasteAttachment,
  getR9ProducedWaterWastes,
  getR9ProducedWaterWaste,
  createR9ProducedWaterWaste,
  updateR9ProducedWaterWaste,
  deleteR9ProducedWaterWaste,
  getR9ProducedWaterWasteAttachments,
  addR9ProducedWaterWasteAttachment,
  deleteR9ProducedWaterWasteAttachment,
  getR9Invoices,
  getR9Invoice,
  updateR9Invoice,
  approveR9Invoice,
  rejectR9Invoice,
  deleteR9Invoice,
  generateAndSaveInvoicePdf,
};

